import React from "react";
import { Link } from "react-router-dom";

import Logo from "./logo";
import "./styles/navBar.css";

const links = [
	{ label: "Home", path: "/", key: "home" },
	{ label: "Work", path: "/projects", key: "projects" },
	{ label: "Services", path: "/software-development-lifecycle", key: "services" },
	{ label: "About", path: "/about", key: "about" },
	{ label: "Contact", path: "/contact", key: "contact" },
];

const NavBar = ({ active }) => (
	<header className="nav-container">
		<div className="nav-shell">
			<Link className="nav-brand" to="/" aria-label="Lunexa Labs home">
				<Logo width={34} link={false} />
				<span>Lunexa Labs</span>
			</Link>

			<nav className="navbar" aria-label="Primary navigation">
				<ul className="nav-list">
					{links.map((item) => (
						<li className={active === item.key ? "nav-item active" : "nav-item"} key={item.key}>
							<Link to={item.path}>{item.label}</Link>
						</li>
					))}
				</ul>
			</nav>
		</div>
	</header>
);

export default NavBar;
